// Ported from the Messenger onboarding file and QR validation helpers.
export const MAX_SESSION_BYTES = 2 * 1024 * 1024;
export const MAX_METADATA_BYTES = 64 * 1024;

export function sessionMetadata(parsed) {
  if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') throw new Error('В JSON должен быть объект с данными аккаунта.');
  return Object.fromEntries(['phone', 'app_id', 'app_hash', 'user_id', 'first_name', 'last_name', 'name']
    .filter(key => ['string', 'number'].includes(typeof parsed[key]))
    .map(key => [key, parsed[key]]));
}

export function sessionFiles(files) {
  const list = Array.from(files || []);
  const session = list.filter(file => file.name.toLowerCase().endsWith('.session'));
  const metadata = list.filter(file => file.name.toLowerCase().endsWith('.json'));
  if (list.length !== 2 || session.length !== 1 || metadata.length !== 1) {
    throw new Error('Выберите вместе два файла одного аккаунта: .session и .json.');
  }
  if (!session[0].size || session[0].size > MAX_SESSION_BYTES) throw new Error('Файл .session должен быть непустым и не больше 2 МБ.');
  if (!metadata[0].size || metadata[0].size > MAX_METADATA_BYTES) throw new Error('Файл .json должен быть непустым и не больше 64 КБ.');
  return { session: session[0], metadata: metadata[0] };
}

export async function encodeSession(file) {
  if (!file?.size || file.size > MAX_SESSION_BYTES) throw new Error('Файл .session должен быть непустым и не больше 2 МБ.');
  const bytes = new Uint8Array(await file.arrayBuffer());
  if (!bytes.length || bytes.length > MAX_SESSION_BYTES) throw new Error('Не удалось прочитать файл .session.');
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += 8192) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 8192));
  }
  return btoa(binary);
}

export function safeQrImage(value) {
  return typeof value === 'string' && /^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/.test(value) ? value : null;
}

export function codeDeliveryHint(delivery) {
  return ({
    telegram: 'Откройте служебный чат Telegram (777000) на устройстве, где уже выполнен вход. Если чат не виден, проверьте Архив.',
    sms: 'Введите код из SMS на указанный номер.',
    call: 'Дождитесь звонка Telegram на указанный номер и введите полученный код.',
    email: 'Введите код из письма Telegram. Проверьте также папку «Спам».',
  })[delivery] || 'Введите самый свежий код подтверждения способом, который предложил Telegram.';
}

export function onboardingState(flow) {
  const state = String(flow?.state || flow?.status || flow?.authorization_state || '').toLowerCase();
  if (['ready', 'online', 'completed', 'authorized'].includes(state)) return 'ready';
  if (['wait_password', 'waiting_for_password', 'password_required', 'authorizationstatewaitpassword'].includes(state)) return 'password';
  if (['waiting_for_qr', 'wait_qr', 'authorizationstatewaitotherdeviceconfirmation'].includes(state)) return 'qr';
  if (['wait_code', 'waiting_for_code', 'code_required', 'authorizationstatewaitcode'].includes(state)) return 'code';
  if (['failed', 'error', 'cancelled'].includes(state)) return 'failed';
  return 'connecting';
}

export function onboardingErrorMessage(error) {
  const code = String(error?.response?.data?.code || error?.code || '').toUpperCase();
  if (code === 'AUTH_CLEANUP_PENDING') return 'Подключение ещё останавливается. Повторите отмену через несколько секунд.';
  if (code === 'AGENT_ALREADY_EXISTS') return 'Этот Telegram-аккаунт уже добавлен в TeleFarm.';
  if (code === 'TELEGRAM_VERIFICATION_REQUIRED') return 'Telegram запросил дополнительную проверку приложения. Обратитесь к руководителю.';
  if (code === 'AGENT_CREDENTIAL_SOURCE_UNAVAILABLE') return 'Серверные данные Telegram-приложения временно недоступны. Обратитесь к руководителю.';
  if (code === 'AGENT_SESSION_OFFLINE') return 'Telegram-сессия агента сейчас не в сети. Подождите подключения и попробуйте ещё раз.';
  if (code === 'TELEGRAM_PROFILE_RATE_LIMITED') return 'Telegram временно ограничил изменения профиля. Попробуйте позже.';
  if (code === 'TELEGRAM_PROFILE_UPDATE_FAILED') return 'Telegram не применил изменения профиля. Проверьте данные и попробуйте ещё раз.';
  if (code === 'PHONE_CODE_INVALID') return 'Код не подошёл. Введите самый свежий код подтверждения Telegram.';
  if (code === 'PHONE_CODE_EXPIRED') return 'Срок действия кода закончился. Начните добавление заново, чтобы получить новый код.';
  if (['PASSWORD_HASH_INVALID', 'PASSWORD_INVALID'].includes(code)) return 'Неверный пароль двухэтапной аутентификации.';
  if (code === 'ONBOARDING_EXPIRED') return 'Время добавления истекло. Начните заново — аккаунт не был подключён.';
  return error?.response?.data?.message || error?.message || 'Не удалось подключить аккаунт. Попробуйте ещё раз.';
}
